import './ExportLoadingIndicator.style.less'
import lottie from 'lottie-web'
import loadingFile from '@/assets/lottie/data.json'
import { ReactNode, useEffect } from 'react'

interface ExportLoadingIndicatorProps {
  title?: ReactNode
  loop?: boolean
}

function ExportLoadingIndicator({
  title = (
    <>
      Processing your request - you may continue working. <br />
      The download will start automatically.
    </>
  ),
  loop = true,
}: ExportLoadingIndicatorProps) {
  useEffect(() => {
    const container = document.querySelector('#export-react-logo')
    let animation: any = null
    if (container) {
      animation = lottie.loadAnimation({
        container: container as any,
        animationData: loadingFile,
        renderer: 'svg',
        loop,
        autoplay: true,
      })
    }
    return () => {
      if (animation) {
        animation.destroy()
      }
    }
  }, [loop])

  return (
    <div className="export-loading">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div id="export-react-logo" style={{ width: 400, height: 400 }} />
        <h2 style={{ margin: 0, marginTop: '-120px', textAlign: 'center' }}>
          {title}
        </h2>
      </div>
    </div>
  )
}

export default ExportLoadingIndicator
